import { get, set } from "idb-keyval";

interface IdentifiableItem {
  id: string | number;
}

export const IndexDBService = {
  get: async <T>(key: string): Promise<T | null> => {
    try {
      const data = await get(key);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error(`Error getting ${key} from IndexDB:`, error);
      return null;
    }
  },

  set: async <T>(key: string, value: T): Promise<void> => {
    try {
      await set(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error setting ${key} in IndexDB:`, error);
    }
  },

  updateBatch: async <T extends IdentifiableItem>(storeName: string, items: T[]): Promise<void> => {
    try {
      await Promise.all(
        items.map((item) =>
          set(`${storeName}:${item.id}`, JSON.stringify(item))
        )
      );
    } catch (error) {
      console.error("Error in batch update:", error);
      throw error;
    }
  },

  handleError: (operation: string) => (error: Error) => {
    console.error(`IndexDB ${operation} error:`, error);
    throw error;
  },
};
